import { createRoot } from 'react-dom/client';
import './App.css';
import { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from './store/Provider';
import { routes } from './routes';
import ScrollToTop from './components/ScrollToTop';
import './registerSW';

createRoot(document.getElementById('root')).render(
    <HelmetProvider>
        <Provider>
            <Router>
                <ScrollToTop />
                <Suspense fallback={
                    <div className="flex items-center justify-center min-h-screen">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0e4d7d]"></div>
                    </div>
                }>
                    <Routes>
                        {routes.map((route, index) => {
                            const Component = route.component;
                            return (
                                <Route key={index} path={route.path} element={<Component />} />
                            );
                        })}
                    </Routes>
                </Suspense>
            </Router>
        </Provider>
    </HelmetProvider>,
);
